import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import localSchemaGenerator from '../utils';

const StoreDetailLocalSchema = ({ store, storeTimings }) => {
  const localSchema = localSchemaGenerator({ store, storeTimings });
  return (
    <Head>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(localSchema),
        }}
      />
    </Head>
  );
};

export default StoreDetailLocalSchema;

StoreDetailLocalSchema.propTypes = {
  store: PropTypes.shape({
    basicInfo: PropTypes.shape({
      storeName: PropTypes.string,
      address: PropTypes.shape({}),
    }),
  }).isRequired,
  storeTimings: PropTypes.arrayOf({}).isRequired,
};
